"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useIntersectionObserver = require("./useIntersectionObserver");
Object.keys(_useIntersectionObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useIntersectionObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useIntersectionObserver[key];
    }
  });
});